import root from 'window-or-global'
import { flattenDeep, compact } from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import * as carol from 'carol'
import AppWrapper from './components/AppWrapper.vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
Vue.use(Meta)
try {
  Vue.use(VueRouter)
} catch (e) {
  console.log(
    `huuh! The Plugins VueRouter and VueI18N are missbehaving if loaded multiple times. Vue lays down the Convention that plugins should be able to be loaded multiple times without any issue (skipping the initialization process). However they are buggy in this regard, this comes up during SSR scenarios. It is safe to just skip the error message. The console log is there to verify if this is still needed.`
  )
}

import Context from './modules/context'
import Index from './components/Index.vue'
import Tracking from 'pkg-bea-tracking'
import DemoRootPage from './components/DemoRootPage.vue'
import Campaigns from 'pkg-bea-campaigns'
import Content from 'pkg-bea-content'
import Ships from 'pkg-bea-ships'
import Searching from 'pkg-bea-searching'
import Booking from 'pkg-bea-booking'
// import Account from 'pkg-bea-account'
import { RealPerson } from 'pkg-frontend-affiliate-realperson-chat'

import { init as initTrinity } from './trinity'

const routes = [
  {
    path: '/deeplinks',
    component: DemoRootPage,
    name: 'index',
  },
  {
    path: '/finden',
    // name: 'searchingIndex',
    component: Index,
    children: Searching.routes,
  },
  {
    path: '/entdecken',
    // name: 'searchingIndex',
    component: Index,
    children: Content.routes,
  },
  {
    path: '/kreuzfahrt/schiffe/',
    // name: 'searchingIndex',
    component: Index,
    children: Ships.routes,
  },
  {
    path: '/buchen',
    // name: 'searchingIndex',
    component: Index,
    children: Booking.routes,
  },
  {
    path: '/kreuzfahrt/angebote',
    component: Index,
    children: Campaigns.routes,
  },
  // {
  //   path: '/preview-account-1',
  //   component: Index,
  //   children: Account.routes,
  // },
  // {
  //   path: '*',
  //   // name: 'searchingIndex',
  //   redirect: '/',
  // },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

Vue.use(Vuex)
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  // getters: {},
  actions: {
    'api/auth/fetchToken': () => {},
  },
  // mutations: {},
  modules: {
    campaigns: Campaigns.store,
    content: Content.store,
    ships: Ships.store,
    searching: Searching.store,
    booking: Booking.store,
    // account: Account.store,
    tracking: Tracking.store,
    appContext: Context,
    realperson: new RealPerson(),
  },
  plugins: compact(
    flattenDeep([
      Campaigns.store.plugins,
      Content.store.plugins,
      Ships.store.plugins,
      Searching.store.plugins,
      Tracking.store.plugins,
      Booking.store.plugins,
      // Account.store.plugins,
    ])
  ),
})

initTrinity(store)

root['$store'] = store
//root['$store'] = store
root['$router'] = router

try {
  Vue.use(VueI18n)
} catch (e) {
  console.log(
    `haa! The Plugins VueRouter and VueI18N are missbehaving if loaded multiple times. Vue lays down the Convention that plugins should be able to be loaded multiple times without any issue (skipping the initialization process). However they are buggy in this regard, this comes up during SSR scenarios. It is safe to just skip the error message. The console log is there to verify if this is still needed.`
  )
}
Vue.config.lang = 'de'

export default (async () => {
  const i18n = new VueI18n(await carol.client.i18n())
  root['$i18n'] = i18n
  await Campaigns.addRoutesAndStores(router, store)

  const app = new Vue({
    i18n,
    store,
    router,
    ...AppWrapper,
  })
  return app
})()

export { store, router }
